import { MasterdataRestService } from './services/masterdata.service';
import { MasterdataService } from './masterdata.provider';

class MasterdataListController implements ng.IComponentController {

    private activePill: any;
    private types: any;

    constructor(private MasterdataService: aboMasterdata.IService, private MasterdataRestService: MasterdataRestService,
    private $state : ng.ui.IStateService, private $stateParams: ng.ui.IStateParamsService, private $timeout: ng.ITimeoutService) {
        'ngInject';
    }

    public $onInit = () => {
        this.activePill = parseInt(this.$stateParams['tab']);
        this.types = this.MasterdataService.getTypes();

        this.types.forEach(item => {
            this.MasterdataRestService.getItems(item.id).then(( data )=> {
                item.data = data;
            })
        });
    }

    public setTab = (index) => {

        this.$timeout(() => {
            this.$state.go('.', { tab: this.activePill }, {notify: false})
        })
       
    } 

}

export const masterdataListComponent: ng.IComponentOptions = {
    controller: MasterdataListController,
    template: require('./masterdata.list.html')
}


// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/masterdata.list.component.ts